<script setup lang="ts">
import LiWithCheck from '../../../../apps/taurex/components/LiWithCheck.vue'

useHead({ title: 'Směna kryptoměn pro právnické osoby' })

const contactRef = ref()
function scrollToContact () {
  contactRef.value.scrollIntoView({ behavior: 'smooth' })
}

const overlimitHighlights = [
  {
    title: 'Rychlost',
    text: 'Vaše prostředky směníme v rámci několika minut',
    icon: 'i-fubex-stopwatch',
  },
  {
    title: 'Jednoduchost',
    text: 'Pohodlně a bez zbytečných překážek',
    icon: 'i-fubex-lightning',
  },
  {
    title: 'Bezpečnost',
    text: 'Zabezpečení je pro nás tou hlavní prioritou',
    icon: 'i-fubex-safe',
  },
  {
    title: 'Nízké náklady',
    text: 'Obchodujte za výhodných podmínek',
    icon: 'i-fubex-price-tag',
  },

]
</script>

<template>
  <div>
    <div bg-gradient-to-br dark:bg-gradient-to-b from="primary-200 dark:neutral-50" via-primary-50 dark="via-50% via-primary-50" to="primary-100 dark:neutral-100">
      <div fubex-container>
        <div :data-test="getCypressId('body-header')" grid grid-cols="1 md:2" items-center gap-32px py-64px lg:py-120px>
          <div paragraph-md text-neutral-900 flex flex-col gap-32px>
            <h1 display-sm sm:display-lg font-700 text-neutral-900>
              Nákup kryptoměn na&nbsp;firmu
            </h1>
            <p max-w-480px>
              Nakupujte kryptoměny na firmu v jakékoli výši a využijte jejich potenciálu.
            </p>
            <ul flex flex-col gap-8px>
              <LiWithCheck>
                Rychlé založení účtu
              </LiWithCheck>
              <LiWithCheck>
                Intuitivní rozhraní pro jednoduché ovládání
              </LiWithCheck>
              <LiWithCheck>
                Česká podpora
              </LiWithCheck>
            </ul>
            <div flex gap-12px flex-col md:flex-row>
              <FButton :data-test="getCypressId('more-button')" name="company-more" size="lg" px-60px @click="scrollToContact">
                Více informací
              </FButton>
            </div>
          </div>
          <div self-center relative>
            <NuxtImg :src="`${'/img/overlimit.webp'}`" alt="" z-1 relative />
          </div>
        </div>
      </div>
    </div>
    <div :data-test="getCypressId('widgets')" class="light" w-full bg-neutral-900 py-60px mb-80px lg:mb-120px>
      <div class="fubex-container">
        <div grid class="grid-cols-[repeat(auto-fit,minmax(200px,270px))]" place-items-center justify-center text-center gap-32px sm:gap-40px>
          <WidgetOverlimitHighlight v-for="(item, index) in overlimitHighlights" :key="index" :title="item.title" :text="item.text" :icon="item.icon" />
        </div>
      </div>
    </div>
    <div class="fubex-container">
      <div :data-test="getCypressId('how-it-works-header')" flex justify-center mt="32px lg:86px" md:mt-116px mb-48px>
        <h2 heading1 text-neutral-900 font-700>
          Jak to funguje?
        </h2>
      </div>
      <WidgetCompanyHowItWork />
    </div>
    <div ref="contactRef" />
    <WidgetContactForm>
      <h2 heading2 font-700 text-white my-12px>
        Konzultace zdarma
      </h2>
      <div text-white>
        Chcete nakupovat kryptoměny na firmu a zajímá Vás, jak proces probíhá?
      </div>
      <div text-white>
        Zanechte nám Váš kontakt a my se Vám ozveme!
      </div>
    </WidgetContactForm>
  </div>
</template>
